<template>
  <div class="neo-step">
    <div class="num">
      <span></span>
      <span>{{ number }}</span>
    </div>
    <div class="text">
      <h6>
        {{ title }} <span v-if="subtitle">{{ subtitle }}</span>
      </h6>

      <p>{{ text }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "NeoStep",
  props: {
    number: {
      type: Number,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      required: true,
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.neo-step {
  display: flex;
  width: 100%;

  &:not(:last-child) {
    margin-bottom: 60px;
  }

  .num {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px;
    width: 50px;
    background: transparent;
    border: 1px solid #ffffff;
    border-radius: 8px;
    position: relative;

    > span:first-child {
      height: 40px;
      width: 40px;
      background: #ffffff;
      border-radius: 8px;
      display: block;
    }

    > span:last-child {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 1.25rem;
      font-weight: 600;
      color: #121212;
      z-index: 2;
    }
  }

  .text {
    color: #ffffff;
    opacity: 1;
    margin-left: 60px;
    width: 60%;

    h6 {
      display: flex;
      align-items: center;
      margin-bottom: 15px;
      span {
        background-color: rgba(0, 164, 137, 0.5);
        padding: 2px 8px;
        border-radius: 10px;
        font-size: 0.825rem;
        color: #fff;
        margin-left: 10px;
      }
    }
    p {
      color: #ffffff;
      font-size: 1.125rem;
      opacity: 0.74;
    }
  }
}

@media (max-width: 768px) {
  .neo-step {
    .num {
      height: 38px;
      width: 40px;
      border-radius: 4px;

      > span:first-child {
        height: 30px;
        width: 30px;
        border-radius: 4px;
      }

      > span:last-child {
        font-size: 1rem;
      }
    }
  }
}

@media (max-width: 600px) {
  .neo-step {
    flex-direction: column;

    .text {
      width: 100%;
      margin-left: 0;
      margin-top: 15px;
    }
    &:not(:last-child) {
      margin-bottom: 40px;
    }
  }
}
</style>
